import * as yup from 'yup';

import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import type { AllgemeinKfzSchema } from '@/features/Sparten/shared/schema/kfz/allgemeinSchema/allgemeinSchema';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';

const vorversicherungsBaseSchema = yup.object({
  gesellschaftID: yup.number().default(0),
  gesellschaftName: yup.string().default(''),
  hasVertragGekuendigt: yup.boolean().default(false),
  dauer: yup
    .number()
    .max(50, 'Bitte Vorversicherung in Jahren angeben.')
    .nullable()
    .optional(),
});

export const vorversicherungRequiredSchema = vorversicherungsBaseSchema.concat(
  yup.object({
    gesellschaftID: yup.number().default(0).required().notOneOf([0]),
    dauer: yup.number().required(),
  }),
);

export const vorversicherungSchema = vorversicherungsBaseSchema.when(
  ['allgemein', 'sfKlasseKH'],
  {
    is: (val: AllgemeinKfzSchema, sfKlasse: string) =>
      val === undefined ||
      (!getSimpleChoiceMeta(
        SIMPLE_CHOICE.SF_KLASSE_KH,
        SIMPLE_CHOICE_META.SF_KLASSE_KH_NOT_RELEVANT_FOR_VORVERSICHERUNG,
      ).includes(sfKlasse) &&
        !getSimpleChoiceMeta(
          SIMPLE_CHOICE.VERSICHERUNGSART_NEUES_FAHRZEUG,
          SIMPLE_CHOICE_META.VERSICHERUNGSART_IS_ERSTVERTRAG_OHNE_VERSICHERUNG,
        ).includes(val.versicherungsart) &&
        !getSimpleChoiceMeta(
          SIMPLE_CHOICE.VERSICHERUNGSART_NEUES_FAHRZEUG,
          SIMPLE_CHOICE_META.VERSICHERUNGSART_NEUES_FAHRZEUG_IS_ZWEITWAGEN,
        ).includes(val.versicherungsart)),

    then: vorversicherungRequiredSchema,
  },
);
